export const FETCH_CAPABILITIES_SUCCESS = "FETCH_CAPABILITIES_SUCCESS";
export const FETCH_CAPABILITIES_ERROR = "FETCH_CAPABILITIES_ERROR";

export const FETCH_CAPABILITY_SUCCESS = "FETCH_CAPABILITY_SUCCESS";
export const FETCH_CAPABILITY_ERROR = "FETCH_CAPABILITY_ERROR";

export const CREATE_CAPABILITY_SUCCESS = "CREATE_CAPABILITY_SUCCESS";
export const CREATE_CAPABILITY_ERROR = "CREATE_CAPABILITY_ERROR";

export const UPDATE_CAPABILITY_SUCCESS = "UPDATE_CAPABILITY_SUCCESS";
export const UPDATE_CAPABILITY_ERROR = "UPDATE_CAPABILITY_ERROR";

export const DELETE_CAPABILITY_SUCCESS = "DELETE_CAPABILITY_SUCCESS";
export const DELETE_CAPABILITY_ERROR = "DELETE_CAPABILITY_ERROR";
